"use client";
import React from "react";
import { PageManifestoSchema } from "@/sanity/pages/PageManifestoTemplate";
import NavBarV2 from "@/components/global/partials/HeaderV2";
import Footer from "@/components/global/partials/Footer";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { PortableText } from "next-sanity";
import Image from "@/helpers/Image";

import statue from "@/public/manifesto/conclusion.png";
import differenceBg from "@/public/manifesto/differenceBg.jpg";
import missionBg from "@/public/manifesto/missionBg.png";
import missionBgM from "@/public/manifesto/missionBgMobile.png";
import missionLogo from "@/public/manifesto/missionLogo.svg";
import missionImage from "@/public/manifesto/missionImage.png";
import CryptoPillar from "@/components/global/ui/CryptoPillar";
import { motion } from "framer-motion";

export default function ConclusionSection({
  data,
}: {
  data: PageManifestoSchema;
}) {
  return (
    <>
      <section id="conclusion">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0,
            ease: [0.25, 0.4, 0.25, 1],
          }}
          viewport={{ once: true }}
          className="w-[min(94.25rem,100%)] mx-auto bg-gradient-to-b from-[#FBFBFB] from-[-34.16%] to-[#E6F2EB] rounded-[2rem] lg:rounded-[4rem] px-[3rem] lg:px-[7rem] pt-[3rem] lg:pt-[7rem] flex flex-col"
        >
          {data?.conclusionTitle && (
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.8,
                delay: 0.2,
                ease: [0.25, 0.4, 0.25, 1],
              }}
              viewport={{ once: true }}
              className="richtext richtext-start w-full mb-[3rem]
              prose-h2:text-[4rem] lg:prose-h2:text-[4.5rem] prose-h2:mb-[3rem]"
            >
              <PortableText
                value={data.conclusionTitle}
                components={richTextComponent}
              />
            </motion.div>
          )}
          {data?.conclusionContent && (
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.8,
                delay: 0.4,
                ease: [0.25, 0.4, 0.25, 1],
              }}
              viewport={{ once: true }}
              className="richtext richtext-start gap-[2rem]
              prose-p:my-0 prose-p:leading-[150%]
              prose-strong:font-normal prose-strong:text-black"
            >
              <PortableText
                value={data.conclusionContent}
                components={richTextComponent}
              />
            </motion.div>
          )}

          <motion.div
            className="w-full"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.8,
              delay: 0.4,
              ease: [0.25, 0.4, 0.25, 1],
            }}
            viewport={{ once: true }}
          >
            <Image
              src={statue}
              alt=""
              className="!w-full lg:!w-[73.929rem] mx-auto"
            />
          </motion.div>
        </motion.div>
      </section>
    </>
  );
}
